export default "__VITE_ASSET__B2H1rLfi__"